import { render } from "./Dashboard.vue?vue&type=template&id=e52f547a"
const script = {}
script.render = render

export default script